import i18n from '@/i18n/index';
import { TYPE_DEVIS, TYPE_COMMANDE } from '@/configuration/devisConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import formatDate from '@/services/general/formatDate';

function getDcfLibelle(dcfType) {
  switch (dcfType) {
    case TYPE_DEVIS:
      return i18n.t('ajoutDevis.popUpSelectFace.messageIndispo.devis');
    case TYPE_COMMANDE:
      return i18n.t('ajoutDevis.popUpSelectFace.messageIndispo.commande');
    default:
      return '';
  }
}
function getCommercialMessage(userId, users) {
  if (!userId) return '';
  const user = users.find((u) => u.id === +userId);
  return i18n.t('ajoutDevis.popUpSelectFace.messageIndispo.parCommercial', {
    commercial: nomPrenomGetter(user),
  });
}

export function getMessageIndisoFaceInfo(message, users = []) {
  if (!message) return null;
  const elements = message.split('|')[0].split('@');
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_DANS_VENTE_RESEAU_TEMPOS') === 0) {
    return {
      message: 'ajoutDevis.popUpSelectFace.messageIndispo.faceDansVenteTempos',
      parametres: {
        reseau: elements[4],
        dcfType: getDcfLibelle(elements[1]),
        dcfCode: elements[2],
        commercial: getCommercialMessage(elements[5], users),
        annonceur: elements[3],
        face: elements[6],
      },
    };
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_VENTE_LC') === 0) {
    return {
      message: 'ajoutDevis.popUpSelectFace.messageIndispo.faceVenteLC',
      parametres: {
        dateDebut: formatDate(elements[5]),
        dateFin: formatDate(elements[6]),
        dcfType: getDcfLibelle(elements[1]),
        dcfCode: elements[2],
        commercial: getCommercialMessage(elements[3], users),
        annonceur: elements[7],
        face: elements[8],
      },
    };
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_AFFECTE_LOGISTIQUEMENT') === 0) {
    const elements = message.split('|')[0].split('@');
    return {
      message: 'ajoutDevis.popUpSelectFace.messageIndispo.faceAffecteLogistiquement',
      parametres: {
        reseauDcfLibelle: [elements[1], elements[2], elements[3]].filter(Boolean).join(' - '),
        face: elements[4],
      },
    };
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_ARCHIVE') === 0) {
    return {
      message: 'ajoutDevis.popUpSelectFace.messageIndispo.faceArchive',
      parametres: {
        face: elements[1],
      },
    };
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_INDISPONIBLE') === 0) {
    return {
      message: 'ajoutDevis.popUpSelectFace.messageIndispo.faceIndisponible',
      parametres: {
        face: elements[1],
      },
    };
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_SELECTIONNE_AUCUNE_VENTE') === 0) {
    return { message: 'ajoutDevis.popUpSelectFace.messageIndispo.faceSelectionAucuneVente' };
  }
  return null;
}

export default function getMessageIndisoFace(message, users) {
  const messageInfo = getMessageIndisoFaceInfo(message, users);
  if (!messageInfo) return '';
  return i18n.t(messageInfo.message, messageInfo.parametres);
}
